export const contentIds = {
  titleOne: "cid$#4402720#", // "Continue looking for {0} ticket" (exp 104039)
  titleMany: "cid$#4402688#", // "Continue looking for {0} tickets" (exp 104039)
  oneTicket: "cid$#3107373#", // "ticket"
  manyTickets: "cid$#3107387#", // "tickets"
} as const;
